import React, { useState, useEffect } from 'react';
import { FormCheck, FormLabel } from 'react-bootstrap';
const MultiCheckboxInput = ({ options, value, onChange, showAllOption }) => {
  const [checkedOptions, setCheckedOptions] = useState([]);

  const handleCheckboxChange = optionValue => {
    const newCheckedOptions = checkedOptions.includes(optionValue)
      ? checkedOptions.filter(value => value !== optionValue)
      : [...checkedOptions, optionValue];
    setCheckedOptions(newCheckedOptions);
    onChange(newCheckedOptions);
  };

  const handleAllCheckboxChange = () => {
    setCheckedOptions(checkedOptions.length === options.length ? [] : options.map(option => option.value));
    onChange(checkedOptions.length === options.length ? [] : options.map(option => option.value));
  };

  useEffect(() => {
    setCheckedOptions(value || []);
  }, [value]);

  return (
    <div className="d-flex flex-wrap gap-2">
      {options.map((option, index) => (
        <div key={option.value} className="d-flex align-items-center gap-2">
          {showAllOption && index === 0 && (
            <div className="form-check ml-2 d-flex align-items-center">
              <input
                id={option.value}
                type="checkbox"
                checked={checkedOptions.length === options.length}
                onChange={() => handleAllCheckboxChange()}
                className="form-check-input mt-0"
                style={{ width: 20, height: 20 }}
              />
              <label className="form-check-label p-1 ml-2 midFont" htmlFor={option.value}>
                All
              </label>
            </div>
          )}
          <div className="form-check ml-2 d-flex align-items-center">
            <input
              id={option.value}
              type="checkbox"
              checked={checkedOptions.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
              className="form-check-input mt-0"
              style={{ width: 20, height: 20 }}
            />
            <label className="form-check-label p-1 ml-2 midFont" htmlFor={option.value}>
              {option.label}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};
export default MultiCheckboxInput;
